import { t } from 'i18next';

import { ContextMenuItem } from '../../../../../../../react/components/skyview/context-menu';
import { isDefined } from '../../../../../../../utils/variables';
import { RevertChange } from '../../../../../../elements/design/design-node/design-node';
import { findFaceIdFromIntersection } from '../../../../../../elements/design/design-node/utils/face-node';
import { DesignTool } from '../../../../../design-tool';
import { addAndCommitAction } from '../../utils/actions';
import { deselect } from '../../utils/select';

export const deleteFace = (tool: DesignTool): ContextMenuItem => {
  const faceId = findFaceIdFromIntersection(tool.asset.designNode, tool.intersection);
  const disabled = !isDefined(faceId);

  return {
    title: t('contextMenu.deleteTriangle', { ns: 'skyviewDesign' }),
    action: () => {
      let changes: RevertChange[] = [];

      if (disabled) {
        return;
      }

      addAndCommitAction(tool, {
        commit: () => {
          changes = [tool.asset.designNode.removeFace(faceId)];
          deselect(tool);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
        rollback: () => {
          tool.asset.designNode.revert(changes);
          tool.asset.designNode.refresh();
          tool.asset.refreshMetadata();
        },
      });
      tool.cursorFace.visible = false;
      tool.contextMenuCallback?.();
    },
    disabled,
    hotkey: 'Delete',
  };
};
